import { BackgroundColors } from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { createUseStyles } from 'react-jss';

import { Spacings } from '@picsart/design-system/foundation/spacings';

const useStyles = createUseStyles(
  () => ({
    root: {
      padding: [Spacings.s64, Spacings.s0],
      backgroundColor: BackgroundColors.base,
    },
    imageHolder: {
      width: '100%',
      maxWidth: 656,
      margin: 'auto',
      marginTop: Spacings.s56,
      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        marginTop: Spacings.s0,
        maxWidth: 312,
      },
    },
    title: {
      maxWidth: 768,
      margin: 'auto',
      textAlign: 'center',
      lineHeight: LineHeights.l50,
      fontSize: FontSizes.s42,

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        maxWidth: 280,
        fontSize: FontSizes.s24,
        lineHeight: LineHeights.l28,
      },
    },

    description: {
      maxWidth: 580,
      paddingTop: Spacings.s24,
      margin: 'auto',
      fontSize: FontSizes.s20,
      lineHeight: LineHeights.l28,
      textAlign: 'center',
      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        maxWidth: 280,
        fontSize: FontSizes.s16,
        lineHeight: LineHeights.l24,
      },
    },

    rootFallback: {
      margin: [Spacings.s32, 'auto', Spacings.s56],
      maxWidth: 768,
    },
    titleFallback: {
      margin: [Spacings.s32, Spacings.s0],
      width: 'auto',
      maxWidth: 768,
      height: 88,
    },

    stepWrapperFallback: {
      display: 'flex',
      justifyContent: 'space-around',
      width: 'auto',
      maxWidth: '100%',
    },
    stepFallback: {
      margin: [Spacings.s2, Spacings.s0],
      width: 56,
      height: 56,
      borderRadius: '50%',
    },
    imageFallback: {
      margin: 'auto',
      paddingTop: '50%',
      marginTop: Spacings.s56,
      width: '100%',
      maxWidth: 656,
    },

    descriptionFallback: {
      margin: [Spacings.s24, 'auto', Spacings.s0],
      maxWidth: 580,
      width: 'auto',
      height: 150,
    },
  }),
  {
    name: 'step-slider',
  },
);

export default useStyles;
